import React, { useEffect, useState } from "react";
import Spinner from "react-bootstrap/esm/Spinner";

//Services 
import Api from "../../services/api";

//Components
import HeaderForms from "../../Components/headerForms/HeaderForms";
import BottomBar from "../../Components/bottomBar/bottomBar";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";

//Icones
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { renderStatusBadge } from "../../services/Functions";

const Users = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Api.get("/users/")
      .then((response) => {
        let arr = [];
        response.data.forEach((element) => {
          arr.push({
            Username: element.username,
            Email: element.email,
            Administrador: renderStatusBadge(element.is_admin)
          });
        });
        setData(arr);
      })
      .catch((error) => {
        alert(error);
      });
  }, []);

  return (
    <>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
        }}
        className="filters boxReport"
      >
        <HeaderForms text="Usuários" icon={faUsers} />
        {loading ? (
          <div style={{ marginTop: "20vh" }} className={styles.loader}>
            <Spinner variant="success" animation="border" />
            <strong>Carregando...</strong>
          </div>
        ) : (
          <>
            {data.length > 0 ? (
              <div
                className="TableReport"
                style={{
                  padding: "1vh",
                }}
              >
                <TableList data={data} styleOverflow="styleOverflow"></TableList>
              </div>
            ) : (
              <div className="TableReport">
                <MessageTable message={"Sem dados para processar."} />
              </div>
            )}
          </>
        )}
      </div>
      <BottomBar></BottomBar>
    </>
  );
};

export default Users;
